import { Icon, forwardRef } from "@chakra-ui/react";
import * as React from "react";
export const SvgSparklesIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ React.createElement(Icon, { ref, color: "foreground.secondary", fill: "none", fill: "none", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 1.5C8.9 5.3 10.7 7.1 14.5 8C10.7 8.9 8.9 10.7 8 14.5C7.1 10.7 5.3 8.9 1.5 8C5.3 7.1 7.1 5.3 8 1.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: 1.5 }));
});
export default SvgSparklesIcon;
